import Image from '@/components/UI/Image';
import {
    EFAmazon,
    EFApp,
    EFCapacity,
    EFCycle,
    EFDoubleLight,
    EFFully,
    EFJD,
    EFLBS,
    EFLFP,
    EFOutput,
    EFOutput2,
    EFPort,
    EFPort1,
    EFPort2,
    EFPort3,
    EFRakuten,
    EFShopify,
    EFStream,
    EFWarranty,
    EFWarranty1,
} from '@/components/UI/svg/river2';
import { getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { getProductInfo } from '@/utils/hooks/useProductInfo';

const { EFPic } = createEFPic('/media/river2/pc/');
const { EFPic: EFPic2 } = createEFPic('');
export default function M() {
    const { useEffect, useLang, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['cn', 'uk', 'de', 'fr', 'es', 'it', 'eu', 'cis', 'za', 'au', 'ph']);

    // 第三个时间段
    const linkMap3: any = {
        cn: {
            river2: {
                btns: [{ icon: <EFJD />, link: 'https://item.jd.com/10023368540908.html', text: t('river2.details.sec4_btn_jd'), type: 'JD' }],
            },
            river2max: {
                btns: [{ icon: <EFJD />, link: 'https://item.jd.com/10023352057072.html', text: t('river2.details.sec4_btn_jd'), type: 'JD' }],
            },
            river2pro: {
                btns: [{ icon: <EFJD />, link: 'https://item.jd.com/10060944419352.html', text: t('river2.details.sec4_btn_jd'), type: 'JD' }],
            },
        },
        us: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://us.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://us.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://us.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        za: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://za.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://za.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://za.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        au: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://au.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://au.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://au.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        ca: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ca.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ca.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ca.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        eu: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://eu.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://eu.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://eu.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        uk: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://uk.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://uk.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://uk.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        de: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://de.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://de.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://de.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        fr: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://fr.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://fr.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://fr.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        it: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://it.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://it.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://it.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        es: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://es.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://es.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://es.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        jp: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://jp.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://jp.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://jp.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        ru: {
            river2: {
                btns: [
                    {
                        link: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        link: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2-max',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        link: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2-pro',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        cis: {
            river2: {
                btns: [
                    {
                        link: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        link: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2-max',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        link: 'https://ecoflow-russia.com/products/portativnaya-zaryadnaya-elektrostantsiya-ecoflow-river-2-pro',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        sa: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://www.amazon.ae/dp/B0BFQC1CNQ?ref=myi_title_dp',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://www.amazon.ae/dp/B0BFQB86ZL?ref=myi_title_dp',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: '',
                        link: '',
                        text: t('river2.details.sec4_btn_soon'),
                        theme: 'default',
                        type: 'soon',
                    },
                ],
            },
        },
        br: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://br.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://br.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://br.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        mx: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://mx.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://mx.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://mx.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
        ph: {
            river2: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ph.ecoflow.com/products/river-2-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2max: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ph.ecoflow.com/products/river-2-max-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
            river2pro: {
                btns: [
                    {
                        icon: <EFShopify />,
                        link: 'https://ph.ecoflow.com/products/river-2-pro-portable-power-station',
                        text: t('river2.details.sec4_btn_shopify'),
                        type: 'store',
                    },
                ],
            },
        },
    };

    const river2: any = {
        cls: 'river2',
        img:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1751081751280/1.png'
                : [`M_river2_${locale === 'sa' ? 'uk' : imgSpec}.webp`, `M_river2_${locale === 'sa' ? 'uk' : imgSpec}.png`],
        productName: t('river2.details.sec13_river2'),
        productPrice: t('river2.details.sec13_river2_price'),
        productId: (() => {
            const ids = {
                ph: '9451541430582',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        variantId: (() => {
            const ids = {
                ph: '49116496757046',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        btns: [{ icon: <EFAmazon />, text: t('river2.details.sec13_amazon'), theme: 'white' }],
        icons: [
            { icon: <EFCapacity width="54px" height="54px" />, text: t('river2.details.sec13_list1_icon1_text') },
            { icon: <EFFully width="54px" height="54px" />, text: t('river2.details.sec13_list1_icon2_text') },
            {
                icon: locale === 'ph' ? <EFOutput2 width="54px" height="54px" /> : <EFOutput width="54px" height="54px" />,
                text: t('river2.details.sec13_list1_icon3_text'),
            },
            { icon: <EFStream />, text: t('river2.details.sec13_list1_icon4_text') },
            { icon: <EFLBS width="54px" height="54px" />, text: t('river2.details.sec13_list1_icon5_text') },
            {
                icon: locale === 'ph' ? <EFPort1 width="54px" height="54px" /> : <EFPort width="54px" height="54px" />,
                text: t('river2.details.sec13_list1_icon6_text'),
            },
            { icon: <EFDoubleLight width="54px" height="54px" />, text: t('river2.details.sec13_list1_icon7_text') },
            { icon: <EFLFP width="54px" height="54px" />, text: t('river2.details.sec13_list1_icon8_text') },
            { icon: <EFCycle width="54px" height="54px" />, text: t('river2.details.sec13_list1_icon9_text') },
            {
                icon: locale === 'ph' ? <EFWarranty1 width="54px" height="54px" /> : <EFWarranty width="54px" height="54px" />,
                text: t('river2.details.sec13_list1_icon10_text'),
            },
            { icon: <EFApp width="54px" height="54px" />, text: t('river2.details.sec13_list1_icon11_text') },
        ],
    };

    const river2max: any = {
        cls: 'river2Max',
        img:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1751081751483/2.png'
                : [`M_river2_max_${locale === 'sa' ? 'uk' : imgSpec}.webp`, `M_river2_max_${locale === 'sa' ? 'uk' : imgSpec}.png`],
        productName: t('river2.details.sec13_river2_max'),
        productPrice: t('river2.details.sec13_river2_max_price'),
        btns: [{ icon: <EFRakuten />, text: t('river2.details.sec13_shopify'), theme: 'white' }],
        productId: (() => {
            const ids = {
                ph: '9451541561654',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        variantId: (() => {
            const ids = {
                ph: '51432344518966',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        icons: [
            { icon: <EFCapacity width="54px" height="54px" />, text: t('river2.details.sec13_list2_icon1_text') },
            { icon: <EFFully width="54px" height="54px" />, text: t('river2.details.sec13_list1_icon2_text') },
            {
                icon: locale === 'ph' ? <EFOutput2 width="54px" height="54px" /> : <EFOutput width="54px" height="54px" />,
                text: t('river2.details.sec13_list2_icon3_text'),
            },
            { icon: <EFStream />, text: t('river2.details.sec13_list2_icon4_text') },
            { icon: <EFLBS width="54px" height="54px" />, text: t('river2.details.sec13_list2_icon5_text') },
            {
                icon: locale === 'ph' ? <EFPort2 width="54px" height="54px" /> : <EFPort width="54px" height="54px" />,
                text: t('river2.details.sec13_list2_icon6_text'),
            },
            { icon: <EFDoubleLight width="54px" height="54px" />, text: t('river2.details.sec13_list2_icon7_text') },
            { icon: <EFLFP width="54px" height="54px" />, text: t('river2.details.sec13_list2_icon8_text') },
            { icon: <EFCycle width="54px" height="54px" />, text: t('river2.details.sec13_list2_icon9_text') },
            {
                icon: locale === 'ph' ? <EFWarranty1 width="54px" height="54px" /> : <EFWarranty width="54px" height="54px" />,
                text: t('river2.details.sec13_list2_icon10_text'),
            },
            { icon: <EFApp width="54px" height="54px" />, text: t('river2.details.sec13_list2_icon11_text') },
        ],
    };

    const river2pro: any = {
        cls: 'river2Pro',
        img:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1751081751673/3.png'
                : [`M_river2_pro_${locale === 'sa' ? 'uk' : imgSpec}.webp`, `M_river2_pro_${locale === 'sa' ? 'uk' : imgSpec}.png`],
        productName: t('river2.details.sec13_river2_pro'),
        productPrice: t('river2.details.sec13_river2_pro_price'),
        btns: [{ icon: '', text: t('river2.details.sec13_coming'), theme: 'default' }],
        productId: (() => {
            const ids = {
                ph: '9451541627190',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        variantId: (() => {
            const ids = {
                ph: '49116498067766',
            };
            return ids?.[locale as 'ph'] ?? '';
        })(),
        icons: [
            { icon: <EFCapacity width="54px" height="54px" />, text: t('river2.details.sec13_list3_icon1_text') },
            { icon: <EFFully width="54px" height="54px" />, text: t('river2.details.sec13_list3_icon2_text') },
            {
                icon: locale === 'ph' ? <EFOutput2 width="54px" height="54px" /> : <EFOutput width="54px" height="54px" />,
                text: t('river2.details.sec13_list3_icon3_text'),
            },
            { icon: <EFStream />, text: t('river2.details.sec13_list3_icon4_text') },
            { icon: <EFLBS width="54px" height="54px" />, text: t('river2.details.sec13_list3_icon5_text') },
            {
                icon: locale === 'ph' ? <EFPort3 width="54px" height="54px" /> : <EFPort width="54px" height="54px" />,
                text: t('river2.details.sec13_list3_icon6_text'),
            },
            { icon: <EFDoubleLight width="54px" height="54px" />, text: t('river2.details.sec13_list3_icon7_text') },
            { icon: <EFLFP width="54px" height="54px" />, text: t('river2.details.sec13_list3_icon8_text') },
            { icon: <EFCycle width="54px" height="54px" />, text: t('river2.details.sec13_list3_icon9_text') },
            {
                icon: locale === 'ph' ? <EFWarranty1 width="54px" height="54px" /> : <EFWarranty width="54px" height="54px" />,
                text: t('river2.details.sec13_list3_icon10_text'),
            },
            { icon: <EFApp width="54px" height="54px" />, text: t('river2.details.sec13_list3_icon11_text') },
        ],
    };

    const products = ['us', 'ca'].includes(locale)
        ? [
              { ...river2pro, btns: linkMap3[locale]?.river2pro?.btns },
              { ...river2, btns: linkMap3[locale]?.river2?.btns },
              { ...river2max, btns: linkMap3[locale]?.river2max?.btns },
          ]
        : [
              { ...river2, btns: linkMap3[locale]?.river2?.btns },
              { ...river2max, btns: linkMap3[locale]?.river2max?.btns },
              { ...river2pro, btns: linkMap3[locale]?.river2pro?.btns },
          ];

    const [isEnterA, setIsEnterA] = useState(false);
    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        let timerA: any;
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_M .productList', //触发元素
            offset: -26, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '200%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        sceneA1.on('enter', () => {
            setIsEnterA(true);
            clearTimeout(timerA);
        });
        sceneA1.on('leave', () => {
            setIsEnterA(false);
        });
        controller.addScene(sceneA1);
    }, []);

    const onLink = (link: string, type: string, cls: string, signup = false) => {
        if (signup) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            return;
        }
        try {
            // fb埋点
            if (type === 'amazon') {
                window?.fbq('track', 'AddToWishlist');
            }
            if (type === 'rakuten') {
                window?.fbq('track', 'donate');
            }
            if (type === 'store') {
                window?.fbq('track', 'Search');
            }
            if (type === 'notify') {
                window?.fbq('track', 'Contact');
            }
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: `buy_on_${['store', 'amazon', 'notify'].includes(type) ? (type === 'notify' ? 'store' : type) : 'other'}`,
                button_name:
                    type === 'notify'
                        ? 'Notify Me'
                        : `Buy on ${
                              type === 'amazon'
                                  ? 'Amazon'
                                  : type === 'JD'
                                  ? 'JD'
                                  : ['notify', 'store'].includes(type)
                                  ? 'Ecoflow Store'
                                  : type === 'rakuten'
                                  ? 'Rakuten'
                                  : 'Other'
                          }`,
                product_name: cls === 'river2' ? 'RIVER 2' : cls === 'river2Max' ? 'RIVER 2 Max' : 'RIVER 2 Pro',
                list_name: 'Bottom Product List',
            });
        } catch (e) {
            console.log(e);
        } finally {
            window?.open(link, '_blank');
        }
    };

    const [curProducts, setCurProducts] = useState(products);
    useEffect(() => {
        if (locale !== 'ph') return; // ph 读取价格
        const run = async () => {
            const data = await getProductInfo(products, locale, {
                price: 'productPrice',
            });
            setCurProducts(data);
        };
        run();
    }, [locale]);

    return (
        <div className={`${css.M_13} river2_detials_M`}>
            <div className={`innerBox${isEnterA ? ' isEnterA' : ''}`}>
                <p className="title">{t('river2.details.sec13_title')}</p>
                <ul className="products">
                    {curProducts?.map((product: any, k: number) => (
                        <li className="productList" key={product?.productName + k}>
                            <div className="sticky_box">
                                <p className="productName">{product?.productName}</p>
                                <div className="line"></div>
                            </div>
                            <div className="upperBox">
                                <div className={`imgBox ${product?.cls}`}>
                                    {locale === 'ph' ? (
                                        <EFPic2 name={product?.img} alt={product?.productName} aria-label={product?.productName} />
                                    ) : (
                                        <EFPic name={product?.img} alt={product?.productName} aria-label={product?.productName} />
                                    )}
                                </div>
                                {!['sa'].includes(locale) && <div className="price">{product?.productPrice}</div>}
                                <div className="btns">
                                    {product?.btns?.map((btn: any, m: number) => (
                                        <div className={`btn ${btn?.theme} ${btn?.type}`} key={`${k}_${m}`}>
                                            {btn?.link && (
                                                <div className="link" onClick={() => onLink(btn?.link, btn?.type, product?.cls, btn?.signup)}>
                                                    {btn?.icon && <span className="btnIcon">{btn?.icon}</span>}
                                                    <span className="btnText">{btn?.text}</span>
                                                </div>
                                            )}
                                            {!btn?.link && (
                                                <span className="iconBtnBox">
                                                    {btn?.icon && <span className="btnIcon">{btn?.icon}</span>}
                                                    <span className="btnText">{btn?.text}</span>
                                                </span>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <ul className="lowerBox">
                                {product?.icons?.map((icon: any, n: number) => (
                                    <li className="iconItem" key={`iconItem_${n}`}>
                                        {icon?.icon && <span className="iconIcon">{icon?.icon}</span>}
                                        {icon?.img && (
                                            <div className={`icon-img-box`}>
                                                <Image src={icon?.img} layout="fill" alt={icon?.text} aria-label={icon?.text} />
                                            </div>
                                        )}
                                        <p className="iconText">{icon?.text}</p>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
